import classNames from 'classnames';
import { PropsWithChildren } from 'react';

type OnboardingIconContainerProps = {
  className?: string;
};

export const OnboardingIconContainer = ({ children, className }: PropsWithChildren<OnboardingIconContainerProps>) => {
  return (
    <div
      className={classNames(
        'flex items-center justify-center w-[5.25rem] h-[5.25rem] rounded-full border-[0.0938rem] border-black-lighter-13',
        className,
      )}
    >
      {children}
    </div>
  );
};
